module.exports = __webpack_public_path__ + "static/media/allalerts_train_hover.6c1e7293.svg";